const headerLayoutSaved = localStorage.getItem('_header_layout_name')

export default {
  layout: {
    header: headerLayoutSaved || '',
    navbarOpen: false,
    // Topかどうか知る
    isTop: false,
    scroll: {
      scroll200: false,
    },
    loading: true,
  },
}
